export const authAnalyticsEvents = [
  'loginBiometrieGestart',
  'loginAcmIdmGestart',
  'loginBiometrieFout',
  'biometrieEnabled',
  'biometrieDisabled',
  'logout',
] as const;
